// src/pages/expense/cafe/gasanDraftConfig.js
// ✅ 전 사업 확산 [5] — 카페인 가산점의 businessConfig. 환경/종합과 동일한 공통
// 컴포넌트(pages/expense/_shared/ExpenseDraft*.jsx)에 이 config를 넘긴다.
// 템플릿 9종은 DocumentTypeSelector.jsx의 "expense_draft-CAFE_INN_가산" 목록과
// expenseTemplates.js의 gasan_* 정의를 그대로 재사용(이미 실사용 데이터(50건) 근거로
// 설계돼 있던 것 — 소독과 달리 카페는 이 통합 페이지 착수 전에 템플릿이 이미 완비돼
// 있었음, 전 사업 확산 [5] 조사 결과).
//
// ✅ 포스임대료/신용카드결제/사회보험료는 세부내역 표 열 구성이 사업마다 제각각이라
// (품목/인건비 표준 패널과 안 맞음) genericTablePanelTemplates(GenericDetailTablePanel,
// 이번 커밋에서 신설)로 처리 — 재료구매/상품구매/소모품구매는 반대로 표가 아니라
// 자유 텍스트 적요라 패널 자체가 필요 없다.
import { makeExpenseDraftConfig } from "../_shared/expenseDraftConfig";
import VendorPanel from "../_shared/VendorPanel";
import ExpenseItemPanel from "../_shared/ExpenseItemPanel";
import SalaryPanel from "./SalaryPanel";

// ── 9종 — Intl.Collator("ko") 정렬 검증 완료(DocumentTypeSelector.jsx와 동일 순서) ──
const TEMPLATES = [
  { code: "gasan_maintenance", label: "관리비" },
  { code: "gasan_payroll", label: "급여지급" },
  { code: "gasan_social_insurance", label: "사회보험료" },
  { code: "gasan_goods", label: "상품구매" },
  { code: "gasan_supplies", label: "소모품구매" },
  { code: "gasan_credit_card", label: "신용카드결제" },
  { code: "gasan_internet", label: "인터넷·전화요금" },
  { code: "gasan_ingredient", label: "재료구매" },
  { code: "gasan_pos_rental", label: "포스임대료" },
];

// ✅ 종류 선택 시 자동 채워지는 구분/내용/분야 — CafeGasanExpense 실측(50건) 근거
// 기본값. item_name은 매번 달라지는 구체 품목(예: "핫도그")은 비워두고, 값이
// 고정적인 것만 채운다.
const CATEGORY_ITEM_FIELD_DEFAULTS = {
  gasan_ingredient: { category_name: "가산점 재료비", item_name: "", field_name: "구입" },
  gasan_goods: { category_name: "상품매입비", item_name: "", field_name: "구입" },
  gasan_supplies: { category_name: "소모품", item_name: "", field_name: "구입" },
  gasan_pos_rental: { category_name: "사무관리비", item_name: "포스 임대료", field_name: "납부" },
  gasan_internet: { category_name: "공공운영비", item_name: "인터넷 및 전화 요금", field_name: "납부" },
  gasan_credit_card: { category_name: "(정산 용도)수수료 합계", item_name: "(정산 용도)수수료 합계", field_name: "정산" },
  gasan_payroll: { category_name: "급여", item_name: "카페인 가산점 급여", field_name: "지급" },
  gasan_social_insurance: { category_name: "연금부담금 등", item_name: "사회보험료", field_name: "납부" },
  gasan_maintenance: { category_name: "사무관리비", item_name: "가산점 관리비", field_name: "납부" },
};

const SALARY_PANEL_TEMPLATES = ["gasan_payroll"];
const GENERIC_TABLE_PANEL_TEMPLATES = ["gasan_pos_rental", "gasan_credit_card", "gasan_social_insurance"];

const gasanDraftConfig = makeExpenseDraftConfig({
  namespace: "cafe-gasan-draft",
  category: "CAFE_INN_가산",
  businessLabel: "카페인 가산점",
  // ✅ (구) 페이지가 실제로 쓰는 CafeGasanExpense.draft_no 접두어와 정확히 일치(DB
  // 실측: 기존 50건 전부 "금천일자리(주)CAFE_INN 가산점지출").
  draftNoPrefix: "금천일자리(주)CAFE_INN 가산점지출",
  dataApiBase: "/expense/cafe/gasan/",
  combinedCreateApi: "/expense/cafe/gasan/draft/",
  newRoutePath: "/expense/cafe/gasan/draft/new",
  listRoutePath: "/expense/cafe/gasan/draft/list",
  previewRoutePath: "/expense/cafe/gasan/draft/preview",
  templates: TEMPLATES,
  categoryItemFieldDefaults: CATEGORY_ITEM_FIELD_DEFAULTS,
  itemPanelTemplates: [],
  salaryPanelTemplates: SALARY_PANEL_TEMPLATES,
  genericTablePanelTemplates: GENERIC_TABLE_PANEL_TEMPLATES,
  // fieldNameMap 생략 — CafeGasanExpenseSerializer가 이미 category_name/item_name/
  // field_name으로 env_total과 동일하게 노출하므로 기본값 그대로 사용.
  VendorPanel,
  ExpenseItemPanel,
  SalaryPanel,
});

export default gasanDraftConfig;

